import { useTranslation } from 'next-i18next';
import React, { } from 'react';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import Boton from '@/components/elements/Boton';

function RowPremiumEstadisticas() {

    const { t } = useTranslation();

    const irAPremium = () => {
        window.open("/dashboard/premium", "_self");
    }

    return (
        <section
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '250px',
                backgroundImage: "url('/images/estadisticas_premium_busquedas_blur.jpg')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: '12px',
                padding: '1rem',
            }}
        >
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', width: "100%" }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', width: '100%' }}>
                    <TituloSeccionH2 texto={t("menu:secciones.estadisticas.premium.titulo")} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '1rem' }}>
                    <Boton texto={t("common:errores.hacerse_premium")} onClick={irAPremium} />
                </div>
            </section>
        </section>
    );
}

export default RowPremiumEstadisticas;